import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

import deliveryViaRoadFields from './deliveryViaRoad.fields'

const config: SkyNetTableConfig<DailyOpsFields> = {
    name: 'DeliveryViaRoadPickUp',
    tabs: [{
        name: 'Delivery: Add Pick-up',
        url: CommonRoutes.All,
        fields: deliveryViaRoadFields,
    }],
}

export default config
